import { Component, Input } from '@angular/core';

@Component({
    selector: 'astrea-internal-banner',
    templateUrl: './internal-banner.component.html',
    styleUrls: ['./internal-banner.component.scss'],
    standalone: false
})
export class InternalBannerComponent {

  @Input() title!: string;
  @Input() image!: string;
  @Input() breadcrumbText!: string;
  @Input() breadcrumLink!: string;

  constructor() { }

}
